import { render, staticRenderFns } from "./Forfeit.vue?vue&type=template&id=2a79a6f1&"
import script from "./Forfeit.vue?vue&type=script&lang=js&"
export * from "./Forfeit.vue?vue&type=script&lang=js&"
import style0 from "./Forfeit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports